export async function extractTextFromImage(source, onProgress) {
  if (!source) throw new Error('No image source available for OCR');
  const { createWorker } = await import('tesseract.js');
  const worker = await createWorker('eng', 1, {
    logger: message => {
      if (typeof onProgress === 'function' && typeof message?.progress === 'number') {
        onProgress(Math.round(message.progress * 100));
      }
    }
  });
  try {
    const result = await worker.recognize(source);
    return String(result?.data?.text || '').trim();
  } finally {
    await worker.terminate();
  }
}